export default "__VITE_PUBLIC_ASSET__a4898199__"